import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useClientBranchesAccess = ({ clientId }) => {
  const { accountId } = useAccount();
  const queryClient = useQueryClient();
  const storeKey = ['client-branches-access', accountId, clientId];
  const { isLoading, data } = useQuery(
    storeKey,
    () => api.fetchClientBranchesAccessConfiguration({ accountId, clientId }),
    {
      enabled: !!clientId && !!accountId
    }
  );

  const { mutateAsync: updateConfiguration } = useMutation(
    (configuration) => api.updateClientBranchesAccessConfiguration({ accountId, clientId, configuration }),
    { onSuccess: () => queryClient.invalidateQueries(storeKey) }
  );

  return {
    isLoading,
    configurations: (data || {}).data || [],
    updateConfiguration
  };
};

export default useClientBranchesAccess;
